export default {
  root: {
    width: '100%',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column'
  },
  content: {
    flex: 1,
    overflowY: 'scroll',
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 3,
    paddingBottom: 5
  }
};
